<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-27 16:27:51
 * @Description: 晨会/数据统计
-->
<template>
  <div class="publicStatic">
    <div>
      <el-row
        :gutter="24"
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-bottom: 10px;"
      >
        <el-col :span="6">
          <el-row type="flex">
            <div style="margin-right: 10px;">
              <el-input
                size="mini"
                placeholder="请输入部门名称"
                v-model="form.deptName"
              ></el-input>
            </div>
            <div>
              <el-input
                size="mini"
                placeholder="请输入提交人"
                v-model="form.submitPerson"
              ></el-input>
            </div>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row
            :gutter="24"
            type="flex"
            class="row-bg"
            justify="space-between"
          >
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
            <div>
              <el-button
                @click="searchData"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >查询</el-button
              >
              <el-button
                @click="reset"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >重置</el-button
              >
            </div>
          </el-row>
        </el-col>
        <el-col :span="1" :offset="4">
          <div style="display: flex;align-items: center;">
            <el-button @click="exportData" size="mini" type="primary"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-table
          :data="onLineTableData"
          style="width: 100%"
          height="600"
          border
        >
          <el-table-column label="序号" type="index" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="serialNum"
            align="center"
            label="流水号"
          ></el-table-column>
          <el-table-column
            prop="showTime"
            label="日期"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deptName"
            label="所属部门"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="submitPerson"
            label="提交人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remarkRatio"
            label="点评率"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="synthesisScore"
            label="综合得分"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="viewDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin-top: 10px;"
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
    <el-dialog title="查看" :visible.sync="dialogVisible" width="30%">
      <div class="formBox">
        <div class="formItem" v-for="item in grayDataColumn" :key="item.label">
          <div class="formItem_content">
            <label class="labelItem">{{ item.label }}</label>
            <span>{{ scoreData[item.prop] }}</span>
          </div>
        </div>
      </div>
      <div class="grayGet">
        <h4 style="position: absolute;left: 18px;">综合得分</h4>
        <div style="display: flex;justify-content: center;align-items: center;">
          <span style="color: red;font-weight: bolder;">{{ scoreData.synthesisScore }}</span>
        </div>
      </div>
      <h4>各模块得分</h4>
      <div class="formBox">
        <div
          v-for="i in moduleList"
          :key="i.label"
          style="display: flex;justify-content: center;"
          class="formItem"
        >
          <div class="formItem_content">
            <label class="labelItem">{{ i.label }}</label>
            <span>{{ scoreData[i.prop] }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDataPage,
  getDataPageDetail,
  dataStatisticsExport
} from "@/api/morningMeet";

export default {
  name: "DataStatistical",
  data() {
    return {
      form: {
        deptName: "",
        submitPerson: "",
        startDate: "",
        endDate: ""
      },
      dateTime: [],
      onLineTableData: [],
      pageType: {
        pageSize: 10,
        pageNumber: 1
      },
      total: undefined,
      dialogVisible: false,
      grayDataColumn: [
        {
          label: "流水号：",
          prop: "serialNum"
        },
        {
          label: "日期：",
          prop: "showTime"
        },
        {
          label: "提交人：",
          prop: "submitPerson"
        }
      ],
      moduleList: [
        {
          label: "平台增效：",
          prop: "ptzxScore"
        },
        {
          label: "时事新闻：",
          prop: "ssxwScore"
        },
        {
          label: "关键工作及日清：",
          prop: "gjgzScore"
        },
        {
          label: "走出去行动及成果：",
          prop: "zcqxdScore"
        },
        {
          label: "文化分享：",
          prop: "whfxScore"
        },
        {
          label: "日行一善：",
          prop: "rxysScore"
        },
        {
          label: "晨会创新：",
          prop: "chcxScore"
        },
        {
          label: "现场把控：",
          prop: "xcbkScore"
        }
      ],
      scoreData: {}
    };
  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    searchData() {
      this.getEmployeeData();
    },
    async getEmployeeData() {
      this.form.startDate = this.dateTime[0];
      this.form.endDate = this.dateTime[1];
      const { code, rows, total } = await getDataPage({
        ...this.form,
        ...this.pageType
      });
      if (code != 0) return;
      this.total = total;
      this.onLineTableData = rows;
    },

    handlePageChange(val) {
      this.pageType.pageNumber = val;
      this.getEmployeeData();
    },
    exportData() {
      this.form.startDate = this.dateTime[0];
      this.form.endDate = this.dateTime[1];
      dataStatisticsExport({ ...this.form, ...this.pageType }).then(res => {
        const exportFileName = decodeURIComponent(res.headers['content-disposition'].match(/filename="([^"]+)"/)[1])||'文件';
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `${exportFileName}.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
    },
    async viewDetail(obj) {
      const { code, data } = await getDataPageDetail({
        serialNum: obj.serialNum
      });
      if (code != 0) return;
      this.scoreData = { ...obj, ...data };
      this.dialogVisible = true;
    },
    reset() {
      Object.keys(this.form).forEach(item => {
        this.form[item] = "";
      });
      this.dateTime = ["", ""];
      this.getEmployeeData();
    }
  }
};
</script>

<style lang="scss" scoped>
.formBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .formItem {
    display: flex;
    .formItem_content {
      width: 220px;
      padding: 3px 0;
      display: flex;
      justify-content: space-between;
      .labelItem {
      }
    }
  }
}
.grayGet {
  height: 60px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/MorningMeeting/DataStatistical.vue